jQuery(function ($){

  slideDownHeader(
    $('.header_slide')
  )

  function slideDownHeader(header) {

    $(window).on('scroll', function(){

      if ($(this).scrollTop() > 500) {
        header.slideDown(400);
      } else {
        header.slideUp(100);
      }

    });

  }

});